import { Sale } from "@towersystems/roam-common/lib/generated-types";
import SaleModel from "./data/model/Sale";

export interface Payment {
  id: string;
  amount: number;
  paymentTypeId: string;
  paymentDate: Date;
}

// the change payment will always be type cash and have a negative amount
// the change payment will always be the last payment in the list
// as it is created 1 second after the other payments
export const guessChangePayment = async (sale: SaleModel | Sale) => {
  // filter out the change payment
  // sort the payments by date

  let sortedPayments: Payment[] = [];

  if (sale instanceof SaleModel) {
    const total = (await sale.totals_ASYNC()).totalPrice;

    sortedPayments =
      total <= 0
        ? []
        : sale.payments
            .filter((p) => !p.state || p.state === "SETTLED")
            .filter((p) => p.paymentTypeId != "2")
            .map(
              (p) =>
                ({
                  id: p.id,
                  amount: p.amount,
                  paymentTypeId: p.paymentTypeId,
                  paymentDate: p.paymentDate,
                } as Payment)
            )
            .sort((p1, p2) => {
              // @ts-ignore
              return p1.paymentDate - p2.paymentDate;
            });
  } else {
    sortedPayments =
      sale.totalPrice <= 0
        ? []
        : sale.payments
            .filter((p) => !p.state || p.state === "SETTLED")
            .filter((p) => p.paymentTypeId != "2")
            .map(
              (p) =>
                ({
                  id: p.id,
                  amount: p.amount,
                  paymentTypeId: p.paymentTypeId,
                  paymentDate: p.paymentDate,
                } as Payment)
            )
            .sort((p1, p2) => {
              // @ts-ignore
              return p1.paymentDate - p2.paymentDate;
            });
  }

  let maybeChangePayment: Payment | undefined =
    sortedPayments[sortedPayments.length - 1];

  if (
    maybeChangePayment &&
    (maybeChangePayment.paymentTypeId !== "1" || maybeChangePayment.amount > 0)
  ) {
    maybeChangePayment = undefined;
  }

  return maybeChangePayment;
};
